var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.3333 3.33332H7.3333V6.66664L10.1866 8.35997L10.6666 7.5533L8.3333 6.16664V3.33332ZM7.99997 0C6.40868 0 4.88256 0.632138 3.75734 1.75735C2.63213 2.88257 1.99999 4.40868 1.99999 5.99998H0L2.63999 8.68663L5.33331 5.99998H3.33332C3.33332 4.7623 3.82498 3.57532 4.70015 2.70016C5.57532 1.82499 6.7623 1.33333 7.99997 1.33333C9.23764 1.33333 10.4246 1.82499 11.2998 2.70016C12.175 3.57532 12.6666 4.7623 12.6666 5.99998C12.6666 7.23765 12.175 8.42463 11.2998 9.2998C10.4246 10.175 9.23764 10.6666 7.99997 10.6666C6.71331 10.6666 5.54664 10.14 4.70665 9.2933L3.75998 10.24C4.3143 10.8004 4.97476 11.2447 5.70278 11.5468C6.43079 11.849 7.21174 12.0031 7.99997 12C9.59126 12 11.1174 11.3678 12.2426 10.2426C13.3678 9.11739 13.9999 7.59127 13.9999 5.99998C13.9999 4.40868 13.3678 2.88257 12.2426 1.75735C11.1174 0.632138 9.59126 0 7.99997 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.c705686bb6e947ff99f664d30792bb6f.svg";
export { ForwardRef as ReactComponent };